/* New Collection section.
   - Load More pagination
   - per-card image carousel (Swiper, lazy) + hover cross-fade / mobile touch arrows
   - size quick-add + AJAX add-to-cart
   - swatch -> card image swap
   - sold-out size -> back-in-stock sheet (Klaviyo)
   - Filter | Sort drawer (relocated to <body> so position:fixed is viewport-relative)
   Visible strings + Klaviyo key come from each root's own data-ncg-config,
   English fallbacks below (see DEFAULT_T / configForCard). */
(function () {
  // The New Search panel (header-group, sitewide) also loads this file so
  // window.NCG.initCards exists everywhere — on Collection / /search pages
  // that already include it via their own section, the tag now appears
  // twice. Guard the whole IIFE so a second execution is a pure no-op.
  if (window.__ncgBooted) return;
  window.__ncgBooted = true;

  var DEFAULT_T = {
    added: 'Added to cart',
    addFail: 'Could not add — open the product page',
    bis: 'Email me when [size] is back',
    notifyTitle: 'Notify me when back in stock',
    selectSize: 'Select a size',
    soldOut: 'Sold out',
    bisOk: 'Thanks — we’ll email you.',
    bisFail: 'Could not subscribe. Try again later.',
    bisBadEmail: 'Enter a valid email.'
  };

  // More than one [data-ncg-root] can be on a page at once — e.g. the New
  // Search panel (sitewide) plus a Collection or /search-results grid.
  // Config and the sold-out sheet used to live in single shared module-level
  // variables, so whichever root booted LAST silently overwrote the others'
  // — a shopper could tap sold-out in the search panel and see the wrong
  // page's sheet, or the wrong Klaviyo key / strings. Both are now keyed by
  // root.id (every root already renders with a real, stable id).
  var configs = {}; // rootId -> { klaviyo, t }

  function configForCard(card) {
    var rootId = card && card.dataset ? card.dataset.ncgRootId : null;
    if (rootId && configs[rootId]) return configs[rootId];
    var keys = Object.keys(configs);
    return keys.length ? configs[keys[0]] : { klaviyo: null, t: DEFAULT_T };
  }

  /* ---------------------------------------------------------------- cart */
  function shopRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function addToCart(variantId) {
    // this theme's real cart drawer is <new-cart-drawer> (assets/new-cart.js),
    // not Dawn's stock <cart-drawer> — use its own public API.
    var drawer = document.querySelector('new-cart-drawer');
    var sectionId = drawer ? drawer.sectionId : 'new-cart-drawer';
    var body = {
      items: [{ id: variantId, quantity: 1 }],
      // ask cart/add.js for the fresh drawer content AND the header icon count
      // in one round trip — the old code fetched neither here, then did a
      // SEPARATE refresh() for the drawer only, so the header cart-icon count
      // never updated after a grid/search quick-add no matter how many items
      // were added.
      sections: [sectionId, 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    return fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) { throw res.data; }
        if (drawer && typeof drawer.applySections === 'function') drawer.applySections(res.data.sections);
        if (window.NewCart && typeof window.NewCart.open === 'function') {
          // content is already fresh (applied above from this same response),
          // so open() shows the right item on its very first frame — no
          // second fetch, no mid-animation jump.
          window.NewCart.open();
        } else {
          setTimeout(function () { window.location = shopRoot() + 'cart'; }, 700);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'new-collection', productVariantId: variantId });
        }
        return res.data;
      });
  }

  /* ------------------------------------------------------------- variants */
  function parseData(card) {
    var el = card.querySelector('[data-ncg-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function sizeValues(card) {
    var d = card._ncg.data, si = card._ncg.sizeIdx;
    if (si < 0) return [];
    var seen = {}, out = [];
    for (var i = 0; i < d.variants.length; i++) {
      var s = d.variants[i].opts[si];
      if (!(s in seen)) { seen[s] = 1; out.push(s); }
    }
    return out;
  }

  function variantFor(card, color, size) {
    var d = card._ncg.data, ci = card._ncg.colorIdx, si = card._ncg.sizeIdx;
    for (var i = 0; i < d.variants.length; i++) {
      var v = d.variants[i];
      if (si > -1 && size != null && v.opts[si] !== size) continue;
      if (ci > -1 && color != null && v.opts[ci] !== color) continue;
      return v;
    }
    return null;
  }

  /* ----------------------------------------------------------------- card */
  function initCard(card) {
    if (card.dataset.ncgCardReady === '1') return;
    card.dataset.ncgCardReady = '1';

    card._ncg = { data: null, colorIdx: -1, sizeIdx: -1, color: null };

    var data = parseData(card);
    if (data) {
      card._ncg.data = data;
      card._ncg.colorIdx = data.colorName ? data.optionNames.indexOf(data.colorName) : -1;
      card._ncg.sizeIdx = data.sizeName ? data.optionNames.indexOf(data.sizeName) : -1;
      var cur = null;
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].id === data.current) { cur = data.variants[i]; break; }
      }
      card._ncg.color = (cur && card._ncg.colorIdx > -1) ? cur.opts[card._ncg.colorIdx] : null;
    }

    bindSlider(card);
    if (!data) return;

    bindSwatches(card);
    buildSizes(card);
    bindSizeClicks(card);
  }

  function bindSlider(card) {
    var slider = card.querySelector('[data-ncg-slider]');
    if (!slider) return;
    var slides = [].slice.call(slider.querySelectorAll('.ncg-card__slide'));
    var prev = card.querySelector('[data-ncg-prev]');
    var next = card.querySelector('[data-ncg-next]');
    if (slides.length < 2) { if (prev) prev.remove(); if (next) next.remove(); return; }

    var inited = false;
    function ensure() {
      if (inited) return;
      inited = true;
      if (typeof window.Swiper === 'function') {
        var sw = new window.Swiper(slider, {
          slidesPerView: 1,
          loop: true,
          speed: 450,
          followFinger: true,
          resistanceRatio: 0.6,
          longSwipesRatio: 0.25,
          threshold: 4
        });
        card._ncg.slideNext = function () { sw.slideNext(); };
        card._ncg.slidePrev = function () { sw.slidePrev(); };
        card._ncg.sliderIndex = function () { return sw.realIndex; };
        card._ncg.hoverShow = function () { sw.slideToLoop(1, 0); };
        card._ncg.slideReset = function () { sw.slideToLoop(0, 0); };
      } else {
        var idx = 0;
        slides.forEach(function (s, k) {
          s.style.position = 'absolute'; s.style.inset = '0';
          s.style.display = k ? 'none' : 'block';
        });
        var show = function (i) {
          idx = (i + slides.length) % slides.length;
          slides.forEach(function (s, k) { s.style.display = k === idx ? 'block' : 'none'; });
        };
        card._ncg.slideNext = function () { show(idx + 1); };
        card._ncg.slidePrev = function () { show(idx - 1); };
        card._ncg.sliderIndex = function () { return idx; };
        card._ncg.hoverShow = function () { show(1); };
        card._ncg.slideReset = function () { show(0); };
      }
    }
    function arm(btn, fn) {
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        ensure(); fn();
      });
    }
    arm(prev, function () { card._ncg.slidePrev(); });
    arm(next, function () { card._ncg.slideNext(); });

    // Build Swiper ahead of time, once the card is about to scroll into
    // view, instead of waiting for the first touch. Building it lazily
    // inside the same touchstart that must also register as "open the
    // product" caused the DOM (loop-mode slide clones) to shift under the
    // finger mid-tap, so the tap-to-click handoff silently failed on iOS
    // Safari (Android's Chrome tolerates the shift and still clicks through).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { ensure(); io.disconnect(); }
      }, { rootMargin: '200px' });
      io.observe(card);
    }

    var CAN_HOVER = window.matchMedia('(hover: hover)').matches;
    if (CAN_HOVER) {
      card.addEventListener('pointerenter', function () {
        ensure();
        if (card._ncg.hoverShow && card._ncg.sliderIndex() === 0) card._ncg.hoverShow();
      });
      card.addEventListener('pointerleave', function () {
        if (card._ncg.slideReset) card._ncg.slideReset();
      });
    }
    var touchHide;
    function ncgShowArrows() { clearTimeout(touchHide); card.classList.add('is-touch'); }
    function ncgHideArrowsLater() {
      clearTimeout(touchHide);
      touchHide = setTimeout(function () { card.classList.remove('is-touch'); }, 2500);
    }
    card.addEventListener('touchstart', function () { ensure(); ncgShowArrows(); }, { passive: true });
    card.addEventListener('touchmove', ncgShowArrows, { passive: true });
    card.addEventListener('touchend', ncgHideArrowsLater, { passive: true });
    card.addEventListener('touchcancel', ncgHideArrowsLater, { passive: true });
  }

  function bindSwatches(card) {
    var box = card.querySelector('[data-ncg-swatches]');
    if (!box) return;
    box.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-ncg-swatch]');
      if (!sw) return;
      e.preventDefault(); e.stopPropagation();
      var color = sw.getAttribute('data-color');
      card._ncg.color = color;
      box.querySelectorAll('[data-ncg-swatch]').forEach(function (s) {
        s.classList.toggle('is-active', s === sw);
      });
      var v = variantFor(card, color, null);
      var img = card.querySelector('.ncg-card__img--main');
      if (v && v.img && img) { img.setAttribute('src', v.img); img.removeAttribute('srcset'); }
      if (v) {
        var base = card._ncg.data.url;
        card.querySelectorAll('a[href]').forEach(function (a) {
          var href = a.getAttribute('href') || '';
          if (href.indexOf(base) === 0) { a.setAttribute('href', base + '?variant=' + v.id); }
        });
      }
      buildSizes(card);
    });
  }

  function buildSizes(card) {
    var box = card.querySelector('[data-ncg-sizes]');
    if (!box) return;
    var sizes = sizeValues(card);
    if (!sizes.length) { box.hidden = true; return; }
    var color = card._ncg.color;
    box.innerHTML = '';
    sizes.forEach(function (sz) {
      var v = variantFor(card, color, sz);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ncg-card__size' + ((!v || !v.available) ? ' is-sold-out' : '');
      b.textContent = sz;
      b.setAttribute('data-size', sz);
      if (v) b.setAttribute('data-variant-id', v.id);
      box.appendChild(b);
    });
    box.hidden = false;
  }

  function bindSizeClicks(card) {
    var box = card.querySelector('[data-ncg-sizes]');
    if (!box) return;
    box.addEventListener('click', function (e) {
      var btn = e.target.closest('.ncg-card__size');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var sold = btn.classList.contains('is-sold-out');
      var vid = btn.getAttribute('data-variant-id');
      if (sold || !vid) { openSheet(card, btn.getAttribute('data-size'), true); return; }
      btn.disabled = true;
      var cardCfg = configForCard(card);
      addToCart(Number(vid))
        .then(function () { toast(cardCfg.t.added); })
        .catch(function () { toast(cardCfg.t.addFail); })
        .then(function () { btn.disabled = false; });
    });
  }

  function toast(msg) {
    var t = document.getElementById('ncg-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ncg-toast';
      t.style.cssText = 'position:fixed;left:50%;bottom:22px;transform:translateX(-50%);background:#111;color:#fff;padding:11px 18px;font:13px/1.35 sans-serif;z-index:99999;max-width:90vw;text-align:center;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.display = 'block';
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.style.display = 'none'; }, 4000);
  }

  /* ---------------------------------------------------------------- sheet */
  var sheets = {};      // rootId -> sheet DOM refs
  var activeSheet = null; // whichever sheet is currently open (only one at a time)

  function initSheet(sheet, rootId) {
    if (!sheet) return;
    var entry = {
      el: sheet,
      title: sheet.querySelector('[data-ncg-sheet-title]'),
      sizes: sheet.querySelector('[data-ncg-sheet-sizes]'),
      bis: sheet.querySelector('[data-ncg-bis]'),
      bisLabel: sheet.querySelector('[data-ncg-bis-label]'),
      bisEmail: sheet.querySelector('[data-ncg-bis-email]'),
      bisMsg: sheet.querySelector('[data-ncg-bis-msg]'),
      card: null
    };
    if (rootId) sheets[rootId] = entry;
    sheet.querySelectorAll('[data-ncg-sheet-close]').forEach(function (el) {
      el.addEventListener('click', closeSheet);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) closeSheet();
    });
    if (entry.bis) entry.bis.addEventListener('submit', submitBis);
  }

  function sheetForCard(card) {
    var rootId = card && card.dataset ? card.dataset.ncgRootId : null;
    if (rootId && sheets[rootId]) return sheets[rootId];
    var keys = Object.keys(sheets);
    return keys.length === 1 ? sheets[keys[0]] : null;
  }

  function openSheet(card, presetSize, soldOnly) {
    var S = sheetForCard(card);
    if (!S) return;
    activeSheet = S;
    var cfg = configForCard(card);
    S.card = card;
    S.sizes.innerHTML = '';
    if (S.bis) { S.bis.hidden = true; if (S.bisMsg) S.bisMsg.hidden = true; }
    S.title.textContent = soldOnly ? cfg.t.notifyTitle : cfg.t.selectSize;

    var color = card._ncg.color;
    sizeValues(card).forEach(function (sz) {
      var v = variantFor(card, color, sz);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ncg-sheet__size' + ((!v || !v.available) ? ' is-sold-out' : '');
      b.textContent = sz;
      b.addEventListener('click', function () {
        if (b.classList.contains('is-sold-out') || !v) { showBis(card, sz); return; }
        addToCart(v.id).then(closeSheet).catch(function () {});
      });
      S.sizes.appendChild(b);
    });

    if (soldOnly && presetSize) showBis(card, presetSize);
    S.el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function showBis(card, size) {
    var S = sheetForCard(card);
    var cfg = configForCard(card);
    if (!S || !S.bis) { if (S) S.title.textContent = cfg.t.soldOut; return; }
    var v = variantFor(card, card._ncg.color, size);
    S.bis.setAttribute('data-variant-id', v ? v.id : '');
    S.bisLabel.textContent = cfg.t.bis.replace('[size]', size);
    S.bis.hidden = false;
    if (S.bisMsg) S.bisMsg.hidden = true;
    if (S.bisEmail) S.bisEmail.focus();
  }

  function closeSheet() {
    if (!activeSheet) return;
    activeSheet.el.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function submitBis(e) {
    e.preventDefault();
    var S = activeSheet;
    if (!S) return;
    var cfg = configForCard(S.card);
    var email = (S.bisEmail.value || '').trim();
    if (!email || email.indexOf('@') < 1) {
      S.bisMsg.hidden = false; S.bisMsg.textContent = cfg.t.bisBadEmail; return;
    }
    var vid = S.bis.getAttribute('data-variant-id');
    if (!cfg.klaviyo || !vid) {
      S.bisMsg.hidden = false; S.bisMsg.textContent = cfg.t.bisFail; return;
    }
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyo), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        S.bisMsg.hidden = false;
        S.bisMsg.textContent = r.ok ? cfg.t.bisOk : cfg.t.bisFail;
        if (r.ok && S.bisEmail) S.bisEmail.value = '';
      })
      .catch(function () {
        S.bisMsg.hidden = false; S.bisMsg.textContent = cfg.t.bisFail;
      });
  }

  /* ------------------------------------------------------------ load more */
  function bindLoadMore(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ncg-more-btn]');
      if (!btn) return;
      var grid = root.querySelector('[data-ncg-grid]');
      var moreWrap = root.querySelector('[data-ncg-more]');
      if (!grid || !moreWrap) return;
      var url = btn.getAttribute('data-next-url');
      if (!url || btn.dataset.loading === '1') return;
      btn.dataset.loading = '1';
      btn.disabled = true;

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('[data-ncg-grid] > li');
          for (var i = 0; i < newItems.length; i++) {
            grid.appendChild(document.importNode(newItems[i], true));
          }
          var newMore = doc.querySelector('[data-ncg-more]');
          moreWrap.innerHTML = newMore ? newMore.innerHTML : '';
          observe(root);
        })
        .catch(function () { btn.dataset.loading = ''; btn.disabled = false; });
    });
  }

  /* --------------------------------------------------------------- observe */
  function observe(root) {
    var cards = root.querySelectorAll('[data-ncg-card]');
    var rootId = root && root.id;
    for (var i = 0; i < cards.length; i++) {
      if (rootId && !cards[i].dataset.ncgRootId) cards[i].dataset.ncgRootId = rootId;
      try { initCard(cards[i]); } catch (e) {}
    }
  }

  /* ------------------------------------------------------- filter | sort */
  function initDrawer(root, drawer) {
    var openBtn = root.querySelector('[data-ncg-filter-open]');
    if (!drawer || !openBtn) return;
    var form = drawer.querySelector('[data-ncg-facets]');
    var applyTimer = null;

    function open() {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 300);
    }

    openBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-ncg-drawer-close]')) { e.preventDefault(); close(); }
      var toggle = e.target.closest('[data-ncg-facet-toggle]');
      if (toggle) { toggle.parentElement.classList.toggle('is-open'); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });

    drawer.addEventListener('change', function (e) {
      if (!e.target.closest('[data-ncg-facets]')) return;
      updateClearState();
      clearTimeout(applyTimer);
      applyTimer = setTimeout(apply, 250);
    });

    var clearLink = drawer.querySelector('[data-ncg-clear]');
    if (clearLink) {
      clearLink.addEventListener('click', function (e) {
        e.preventDefault();
        if (clearLink.classList.contains('is-disabled')) return;
        applyTo(location.pathname);
      });
    }

    function updateClearState() {
      if (!clearLink || !form) return;
      var active = form.querySelectorAll('input[type="checkbox"]:checked').length > 0;
      if (!active) {
        var priceIns = form.querySelectorAll('input[type="number"]');
        for (var i = 0; i < priceIns.length; i++) {
          if (priceIns[i].value !== '') { active = true; break; }
        }
      }
      if (!active) {
        var sortChecked = form.querySelector('input[name="sort_by"]:checked');
        if (sortChecked && sortChecked.value !== form.dataset.ncgDefaultSort) active = true;
      }
      clearLink.classList.toggle('is-disabled', !active);
    }
    updateClearState();

    function buildUrl() {
      var usp = new URLSearchParams();
      var fd = new FormData(form);
      fd.forEach(function (val, key) { if (val !== '') usp.append(key, val); });
      var qs = usp.toString();
      return location.pathname + (qs ? '?' + qs : '');
    }

    function apply() { applyTo(buildUrl()); }

    function applyTo(url) {
      var grid = root.querySelector('[data-ncg-grid]');
      if (grid) grid.classList.add('is-loading');
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          replaceNode(root, doc, '[data-ncg-grid]');
          replaceNode(root, doc, '[data-ncg-more]');
          var newForm = doc.querySelector('[data-ncg-facets]');
          if (newForm && form) {
            var openLabels = {};
            form.querySelectorAll('.ncg-facet.is-open .ncg-facet__toggle').forEach(function (t) {
              openLabels[t.textContent.trim()] = 1;
            });
            form.innerHTML = newForm.innerHTML;
            form.querySelectorAll('.ncg-facet').forEach(function (f) {
              var t = f.querySelector('.ncg-facet__toggle');
              if (t && openLabels[t.textContent.trim()]) f.classList.add('is-open');
            });
          }
          copyText(root, doc, '[data-ncg-head-count]');
          copyText(drawer, doc, '[data-ncg-drawer-count]');
          updateClearState();
          try { history.pushState({ ncg: 1 }, '', url); } catch (e) {}
          observe(root);
        })
        .catch(function () {})
        .then(function () {
          var g = root.querySelector('[data-ncg-grid]');
          if (g) g.classList.remove('is-loading');
        });
    }

    window.addEventListener('popstate', function () {
      applyTo(location.pathname + location.search);
    });
  }

  function replaceNode(scope, doc, sel) {
    var oldEl = scope.querySelector(sel);
    var newEl = doc.querySelector(sel);
    if (oldEl && newEl) oldEl.parentNode.replaceChild(document.importNode(newEl, true), oldEl);
  }
  function copyText(scope, doc, sel) {
    var oldEl = scope.querySelector(sel);
    var newEl = doc.querySelector(sel);
    if (oldEl && newEl) oldEl.textContent = newEl.textContent;
  }

  /* ------------------------------------------------------------------ boot */
  function relocate(node) {
    if (!node) return null;
    if (node.id) {
      var prev = document.getElementById(node.id);
      while (prev && prev !== node) { prev.remove(); prev = document.getElementById(node.id); }
    }
    if (node.parentNode !== document.body) document.body.appendChild(node);
    return node;
  }

  function initRoot(root) {
    if (!root || root.dataset.ncgReady === '1') return;
    root.dataset.ncgReady = '1';

    var cfg = { klaviyo: null, t: {} };
    for (var dk in DEFAULT_T) { cfg.t[dk] = DEFAULT_T[dk]; }
    var cfgEl = root.querySelector('[data-ncg-config]');
    if (cfgEl) {
      try {
        var parsed = JSON.parse(cfgEl.textContent);
        if (parsed) {
          if (parsed.klaviyo) cfg.klaviyo = parsed.klaviyo;
          if (parsed.t) { for (var k in parsed.t) { if (parsed.t[k]) cfg.t[k] = parsed.t[k]; } }
        }
      } catch (e) {}
    }
    if (root.id) configs[root.id] = cfg;

    var drawer = relocate(root.querySelector('[data-ncg-drawer]'));
    var sheet = relocate(root.querySelector('[data-ncg-sheet]'));

    try { initSheet(sheet, root.id); } catch (e) {}
    try { initDrawer(root, drawer); } catch (e) {}
    try { bindLoadMore(root); } catch (e) {}
    observe(root);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ncg-root]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ncg-root]');
    if (root) { root.dataset.ncgReady = ''; initRoot(root); }
  });

  // Public hook for callers outside this engine's own [data-ncg-root] pages
  // (e.g. the New Search panel injecting card-newproduct HTML via its own
  // fetch) to bind carousel/swatch/quick-add behavior on cards it didn't
  // render through initRoot/boot. Safe to call repeatedly — initCard no-ops
  // on an already-bound card. Tags each card with its owning root's id
  // (walked up via .closest) so it resolves the RIGHT sheet/config even
  // when another [data-ncg-root] is also on the page.
  window.NCG = window.NCG || {};
  window.NCG.initCards = function (scope) {
    var container = scope || document;
    var root = container.closest ? container.closest('[data-ncg-root]') : null;
    var rootId = root && root.id;
    var cards = container.querySelectorAll('[data-ncg-card]');
    for (var i = 0; i < cards.length; i++) {
      if (rootId && !cards[i].dataset.ncgRootId) cards[i].dataset.ncgRootId = rootId;
      try { initCard(cards[i]); } catch (e) {}
    }
  };
})();
